<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    @if (!isModificationMode) {
      <h3 class="text-end text-secondary">Création d'un utilisateur</h3>
    }
    @if (isModificationMode) {
      <h3 class="text-end text-secondary">Consultation de l'utilisateur '{{ user?.firstname }}'</h3>
    }
  </div>
  @if (userProfileForm) {
    <form [formGroup]="userProfileForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="row">
          <div class="mb-3 text-secondary col-12">
            <small class="form-text text-secondary">Les champs marqués d'un <em class="text-danger">*</em> sont obligatoires.</small>
          </div>
          <div class="mb-3 col-12 col-xl-12">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="user-status-check" formControlName="active" />
              <label class="form-check-label" for="user-status-check">Actif</label>
            </div>
          </div>
          @if (!userProfileForm.controls?.active.value && userProfileForm.controls?.profile.value === 'STRUCTURE') {
            <div class="mb-3 text-secondary col-12 col-xl-6">
              <label class="required">Inactif depuis le</label>
              <app-datepicker
                id="fieldInactiveSince"
                formControlName="inactiveSince"
                [invalid]="submitted && userProfileForm.controls?.inactiveSince?.invalid"
              ></app-datepicker>
              @if (submitted && userProfileForm.controls?.inactiveSince?.errors?.dateFormat) {
                <small class="form-text text-danger"
                  >La date du début d'inactivité est invalide.</small
                  >
                }
                @if (submitted && userProfileForm.controls?.inactiveSince?.errors?.required) {
                  <small class="form-text text-danger"
                    >La date du début d'inactivité est requise.</small
                    >
                  }
                  @if (submitted && userProfileForm.controls?.inactiveSince?.errors?.currentDateExceeded) {
                    <small class="form-text text-danger"
                      >La date du début d'inactivité doit être inférieure ou égale à la date actuelle.</small
                      >
                    }
                  </div>
                  <div class="mb-3 text-secondary col-12 col-xl-6">
                    <label>Remplacé par</label>
                    <select class="form-select" formControlName="replacedByUserId">
                      <option [ngValue]="" selected></option>
                      @for (referent of referents; track referent) {
                        <option [ngValue]="referent.id" [hidden]="referent.id === user.id">
                          {{ referent.name }}
                        </option>
                      }
                    </select>
                  </div>
                }
                <div class="mb-3 text-secondary col-12 col-xl-6">
                  <label class="required">Nom</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="lastname"
                    [class.is-invalid]="submitted && userProfileForm.controls?.lastname.invalid"
                    />
                  @if (submitted && userProfileForm.controls?.lastname.errors?.required) {
                    <small class="form-text text-danger"
                      >Le nom de l'utilisateur est requis.</small
                      >
                    }
                    @if (submitted && userProfileForm.controls?.lastname?.errors?.pattern) {
                      <small class="form-text text-danger"
                        >Les caractères spéciaux et les numéros ne sont pas autorisés.</small
                        >
                      }
                    </div>
                    <div class="mb-3 text-secondary col-12 col-xl-6">
                      <label class="required">Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="firstname"
                        [class.is-invalid]="submitted && userProfileForm.controls?.firstname.invalid"
                        />
                      @if (submitted && userProfileForm.controls?.firstname.errors?.required) {
                        <small class="form-text text-danger"
                          >Le prénom de l'utilisateur est requis.</small
                          >
                        }
                        @if (submitted && userProfileForm.controls?.firstname?.errors?.pattern) {
                          <small class="form-text text-danger"
                            >Les caractères spéciaux et les numéros ne sont pas autorisés.</small
                            >
                          }
                        </div>
                        <div class="mb-3 text-secondary col-12 col-xl-6">
                          <label class="required">Email</label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="ooff"
                            formControlName="email"
                            [class.is-invalid]="submitted && userProfileForm.controls?.email.invalid"
                            />
                          @if (submitted && userProfileForm.controls?.email.errors?.required) {
                            <small class="form-text text-danger"
                              >L'adresse email de l'utilisateur est requise.</small
                              >
                            }
                            @if (submitted && userProfileForm.controls?.email.errors?.email) {
                              <small class="form-text text-danger"
                                >L'adresse email de l'utilisateur n'est pas valide.</small
                                >
                              }
                            </div>
                            <div class="mb-3 text-secondary col-12 col-xl-6">
                              <label class="required">Profil</label>
                              <select
                                type="text"
                                class="w-100 form-select"
                                formControlName="profile"
                                [class.is-invalid]="submitted && userProfileForm.controls?.profile.invalid"
                                >
                                <option [ngValue]="" selected hidden></option>
                                @for (profileType of profileTypes | keyvalue: stringAscOrder; track profileType) {
                                  <option [ngValue]="profileType.key">
                                    {{ profileType.value }}
                                  </option>
                                }
                              </select>
                              @if (submitted && userProfileForm.controls?.profile.errors?.required) {
                                <small class="form-text text-danger"
                                  >Le profil de l'utilisateur est requis.</small
                                  >
                                }
                              </div>
                              <div class="mb-3 text-secondary col-12 col-xl-6">
                                <label>Habilitations</label>
                                <ng-select
                                  formControlName="clearances"
                                  [items]="clearances"
                                  bindValue="name"
                                  [multiple]="true"
                                  [closeOnSelect]="false"
                                  groupBy="categoryLabel"
                                  [selectableGroup]="true"
                                  [selectableGroupAsModel]="false"
                                  [class.is-invalid]="submitted"
                                ></ng-select>
                              </div>
                              <div class="mb-3 text-secondary col-12 col-xl-6">
                                <label [class.required]="userProfileForm.controls.structure.enabled">Structure</label>
                                <ng-select
                                  id="structure"
                                  [items]="structures"
                                  bindValue="id"
                                  formControlName="structure"
                                  [class.is-invalid]="submitted && userProfileForm.controls?.structure.invalid"
                                  >
                                </ng-select>
                                @if (submitted && userProfileForm.controls?.structure.errors?.required) {
                                  <small class="form-text text-danger"
                                    >La structure est requise.</small
                                    >
                                  }
                                </div>
                                <div class="mb-3 text-secondary col-12 col-xl-6">
                                  <label [class.required]="userProfileForm.controls.structureAddresses.enabled">Points d'accueil</label>
                                  <ng-select
                                    formControlName="structureAddresses"
                                    [items]="allStructureSites"
                                    bindValue="id"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    [class.is-invalid]="submitted && userProfileForm.controls?.structureAddresses.invalid"
                                  ></ng-select>
                                  @if (submitted && userProfileForm.controls?.structureAddresses.errors?.required) {
                                    <small class="form-text text-danger">
                                      Au moins un point d'accueil est requis.
                                    </small>
                                  }
                                </div>
                                <div class="mb-3 text-secondary col-12 col-xl-6">
                                  <label [class.required]="userProfileForm.controls.cliIds.enabled">CLI</label>
                                  <ng-select
                                    formControlName="cliIds"
                                    [items]="clis"
                                    bindValue="id"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    [class.is-invalid]="submitted && userProfileForm.controls?.cliIds.invalid"
                                  ></ng-select>
                                  @if (submitted && userProfileForm.controls?.cliIds.errors?.required) {
                                    <small class="form-text text-danger">
                                      Au moins une CLI est requise.
                                    </small>
                                  }
                                </div>
                                <div class="mb-3 text-secondary col-12 col-xl-6">
                                  <label [class.required]="userProfileForm.controls.ctmIds.enabled">CTM</label>
                                  <ng-select
                                    formControlName="ctmIds"
                                    [items]="ctms"
                                    bindValue="id"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    [class.is-invalid]="submitted && userProfileForm.controls?.ctmIds.invalid"
                                  ></ng-select>
                                  @if (submitted && userProfileForm.controls?.ctmIds.errors?.required) {
                                    <small class="form-text text-danger">
                                      Au moins une CTM est requise.
                                    </small>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="row mb-4">
                              <div ngbAccordion [closeOthers]="false">
                                <div ngbAccordionItem>
                                  <h2 ngbAccordionHeader>
                                    <button ngbAccordionButton class="accordion-button text-secondary">
                                      <span id="contactsTitle">Contacts</span>
                                    </button>
                                  </h2>
                                  <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                      <ng-template>
                                        <div class="col">
                                          @if (user.postalAddresses.length !== 0) {
                                            <table class="table table-sm table-striped table-hover" aria-describedby="contactsTitle">
                                              <thead class="text-secondary bg-light">
                                                <tr>
                                                  <th scope="col" class="text-center">Code postal</th>
                                                  <th scope="col" class="text-center">Ville</th>
                                                  <th scope="col" class="text-center">Numéro de téléphone</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                @for (address of user.postalAddresses; track address) {
                                                  <tr>
                                                    <td class="text-center">{{ address.postalCode }}</td>
                                                    <td class="text-center">{{ address.city }}</td>
                                                    <td class="text-center">{{ address.telephone }}</td>
                                                  </tr>
                                                }
                                              </tbody>
                                            </table>
                                          }
                                          @if (user.postalAddresses.length === 0) {
                                            <p>Aucune adresse.</p>
                                          }
                                        </div>
                                      </ng-template>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row px-3">
                              <div class="d-grid col-12 col-md-6 col-lg-3 ms-lg-auto">
                                <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
                                  <fa-icon icon="ban"></fa-icon>
                                  <span class="ms-3 d-none d-md-block">Annuler</span>
                                </button>
                              </div>
                              <div class="d-grid col-12 col-md-6 col-lg-3">
                                <button class="btn btn-primary d-flex justify-content-center" type="submit">
                                  <fa-icon icon="save"></fa-icon>
                                  <span class="ms-3 d-none d-md-block">Sauvegarder</span>
                                </button>
                              </div>
                            </div>
                          </form>
                        }
                      </div>
